import { BaseModel } from '../base-model';

export interface IUserModel {
  Id?: number;
  Name?: string;
  ShortName?: string;
}
export class UserModel extends BaseModel<IUserModel> implements IUserModel {
  Id?: number;
  Name?: string;
  ShortName?: string;
  /**
   *
   */
  constructor(options?: IUserModel) {
    super(options);
  }
}